/** Shared map-game progress helpers (Categories, Login, etc.) */

export function toSlug(v) {
  return String(v || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
}

export function completedSetFromProgress(prog) {
  const fromCompleted = (Array.isArray(prog?.completedCategories) ? prog.completedCategories : [])
    .flatMap((v) => {
      if (v && typeof v === "object") {
        return [v.id, v._id, v.name, v.categoryId, v.categoryName];
      }
      return [v];
    })
    .map((v) => toSlug(v))
    .filter(Boolean);
  const placedByCategory =
    prog?.placedByCategory && typeof prog.placedByCategory === "object" ? prog.placedByCategory : {};
  const fromPlaced = Object.entries(placedByCategory)
    .filter(([, placed]) => placed && typeof placed === "object" && Object.keys(placed).length > 0)
    .map(([k]) => toSlug(k))
    .filter(Boolean);
  return new Set([...fromCompleted, ...fromPlaced]);
}

function getCategoryCandidates(cat) {
  return [cat?.id, cat?._id, cat?.categoryId, cat?.name].map((v) => toSlug(v)).filter(Boolean);
}

export function isCompletedBySet(cat, doneSet) {
  const candidates = getCategoryCandidates(cat);
  if (!candidates.length || !doneSet?.size) return false;
  const doneKeys = Array.from(doneSet);
  return candidates.some(
    (candidate) =>
      doneSet.has(candidate) || doneKeys.some((k) => k.includes(candidate) || candidate.includes(k))
  );
}

/** Theme uses the map flow when there is a non-empty categories list. */
export function isMapTheme(themeData) {
  const list = Array.isArray(themeData?.categoriesList) ? themeData.categoriesList : [];
  return list.length > 0;
}

/**
 * True when every categoriesList entry is completed (same idea as Categories / GameMap save response).
 */
export function isAllMapCategoriesComplete(themeData, prog) {
  const categories = Array.isArray(themeData?.categoriesList) ? themeData.categoriesList : [];
  if (!categories.length) return false;
  const doneSet = completedSetFromProgress(prog);
  const allKeys = [...new Set(categories.map((c) => toSlug(c?.id || c?.name)).filter(Boolean))];
  const doneCount = allKeys.filter((k) => doneSet.has(k)).length;
  const backendDoneCount = Math.max(0, parseInt(String(prog?.completedCount ?? 0), 10) || 0);
  const isAllDoneByCount = allKeys.length > 0 && backendDoneCount >= allKeys.length;
  const isAllDoneByKeys = allKeys.length > 0 && doneCount >= allKeys.length;
  if (isAllDoneByCount || isAllDoneByKeys) return true;
  return categories.every((cat) => isCompletedBySet(cat, doneSet));
}
